<template>
  <el-form
    ref="form"
    label-position="top"
    :model="form"
    :rules="rules"
    @submit.native.prevent="submit"
  >
    <h1>Konto löschen</h1>

    <el-form-item
      for="password"
      label="Passwort"
      prop="password"
    >
      <el-input
        id="password"
        v-model="form.password"
        autocomplete="current-password"
        type="password"
      />
    </el-form-item>

    <el-form-item prop="confirmed">
      <el-checkbox
        v-model="form.confirmed"
        border
      >
        Ich möchte mein Konto unwiderruflich löschen.
      </el-checkbox>
    </el-form-item>

    <el-button
      :loading="deleteStatus === $config.status.LOADING"
      native-type="submit"
      round
      type="danger"
    >
      Löschen
    </el-button>
  </el-form>
</template>

<script>
import api from '@/api'

export default {
  name: 'CAccountDelete',

  metaInfo: {
    title: 'Konto löschen'
  },

  data () {
    return {
      deleteStatus: this.$config.status.IDLE,
      form: {
        password: '',
        confirmed: false
      },
      rules: {
        password: {
          required: true,
          message: 'Bitte geben Sie Ihr aktuelles Passwort ein.'
        },
        confirmed: {
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('Bitte bestätigen Sie, dass Sie Ihr Konto löschen möchten.'))
            }

            callback()
          }
        }
      }
    }
  },

  methods: {
    submit () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }

        this.deleteStatus = this.$config.status.LOADING

        api.user
          .deleteAccount(this.form.password)
          .then(() => {
            this.$router.push({ name: 'login' })
            this.deleteStatus = this.$config.status.SUCCESS

            this.$notify.success({
              title: 'Konto gelöscht',
              message: 'Ihr Konto wurde erfolgreich gelöscht.',
              duration: 0
            })
          })
          .catch(() => {
            this.$notify.error({
              title: 'Fehler',
              message: 'Ihr Konto konnte leider nicht gelöscht werden.'
            })

            this.deleteStatus = this.$config.status.ERROR
          })
      })
    }
  }
}
</script>
